module.exports = __webpack_public_path__ + "static/media/534JamesPBrawleyDrNW_2018-06-12_99.b23d051d.jpg";